<template>
  <div>
    <template v-if="institution && !institution.kl_assessment">
      <Page404></Page404>
    </template>
    <template v-else>
      <NewEvaluation
        :allows_crud="false"
        :evaluation_id="evaluation_id"
        :instrument_id="instrument_id"
        :evaluator_view="true"
      ></NewEvaluation>
      <NewDashboardCustomFab
        v-if="section"
        :section_id="section.id"
        :show_teacher_views="true"
      ></NewDashboardCustomFab>
    </template>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  name: "EvaluatorView",
  components: {
    NewEvaluation: () =>
      import("@/components/new-evaluations/Evaluation/NewEvaluation"),
    NewDashboardCustomFab: () =>
      import("@/components/dashboard/NewDashboardCustomFab"),
    Page404: () => import("@/components/public/Page404"),
  },
  props: {},
  data() {
    return {
      evaluation_id: Number(this.$route.params.evaluation_id),
      instrument_id: Number(this.$route.params.instrument_id),
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      user: "getUser",
      evaluations: names.NEW_EVALUATIONS,
      sections: names.SECTIONS,
    }),
    evaluation() {
      return this.evaluations.find((x) => x.id == this.evaluation_id);
    },
    section() {
      if (this.evaluation && this.evaluation.scope == 1)
        return this.sections.find((x) => x.id == this.evaluation.scope_id);
      else return null;
    },
  },
  methods: {},
  mounted() {},
  watch: {},
  created() {
    this.$store.dispatch(names.FETCH_NEW_TEST_TYPES);
    this.$store.dispatch(names.FETCH_REDACTION_QUESTION_LENGTH_ANSWERS);
    this.$store.dispatch(names.FETCH_MULTIPLE_QUESTION_SCORE_TYPES);
    this.$store.dispatch(names.FETCH_RUBRIC_PRESETS);
    this.$store.dispatch(names.FETCH_RUBRIC_PRESET_UNITS);
    this.$store.dispatch(names.FETCH_NEW_FILLING_QUESTION_SUB_TYPES);
    this.$store.dispatch(names.FETCH_TAXONOMIES);
  },
};
</script>

<style scoped>
</style>